import { render, staticRenderFns } from "./DescriptionBlock.vue?vue&type=template&id=26d518ac&scoped=true&"
import script from "./DescriptionBlock.vue?vue&type=script&lang=ts&"
export * from "./DescriptionBlock.vue?vue&type=script&lang=ts&"
import style0 from "./DescriptionBlock.vue?vue&type=style&index=0&id=26d518ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d518ac",
  null
  
)

export default component.exports